const ITEMS = [
  'Trust is our Business',
  'From India to the World',
  'Sourced with Care',
  'Prepared for Global Trade',
  'Quality · Transparency · Reliability',
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-8 font-display text-3xl sm:text-4xl lg:text-5xl ${
            i % 2 === 0 ? 'text-forest/85' : 'text-outline italic'
          }`}
        >
          {item}
        </span>
        <span className="inline-block h-2.5 w-2.5 rotate-45 rounded-[3px] bg-gold" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee-section" aria-hidden="true" className="overflow-hidden border-y border-line bg-cream-deep py-8">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);

export default Marquee;
